import { createReducer, on } from '@ngrx/store';

import { DirectoryActions } from './directory.actions';
import { UserDetailState, initialUserDetailState } from './user-detail-state.model';
import { UserDetailActions } from './user-detail.actions';

export const UserDetailReducer = createReducer(
  initialUserDetailState,

  // Handle user selection for global user detail functionality
  on(
    UserDetailActions.init,
    UserDetailActions.initWithUserFromRoute,
    (state: UserDetailState, { user: selectedUser }): UserDetailState => ({ ...state, selectedUser })
  ),

  // Handle clearing selected user
  on(
    DirectoryActions.destroy,
    UserDetailActions.destroy,
    (state: UserDetailState): UserDetailState => ({ ...state, selectedUser: null })
  )
);
